import { ShowBase, useShowContext } from 'react-admin';
import { matchPath, useLocation } from 'react-router-dom';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { GoToListButton } from '../../../components/GoToListButton';
import { OBJECTS_TYPES } from '../../../constants';
import { ComplexAside } from '../ComplexAside';

export const ComplexShow = () => {
	const { pathname } = useLocation();
	const match = matchPath(
		{ path: `objects/${OBJECTS_TYPES.COMPLEXES}/show/:id` },
		pathname
	);

	if (!match) {
		return null;
	}

	const { params } = match;

	return (
		<Box mt={3}>
			<GoToListButton />
			<ShowBase id={params.id} resource={OBJECTS_TYPES.COMPLEXES}>
				<ComplexShowContent />
			</ShowBase>
		</Box>
	);
};

const ComplexShowContent = () => {
	const { record, isPending } = useShowContext();
	if (isPending || !record) return null;

	return (
		<Box mt={4} mb={2} display="flex">
			<Box flex="1">
				<Card>
					<CardContent>
						<Box display="flex">
							<Box ml={2} flex="1">
								<Typography variant="h5">Назва: {record.name}</Typography>
							</Box>
							{/*<Box>*/}
							{/*	<ReferenceField*/}
							{/*		source="company_id"*/}
							{/*		reference="companies"*/}
							{/*		link="show"*/}
							{/*		sx={{ '& a': { textDecoration: 'none' } }}*/}
							{/*	>*/}
							{/*		<CompanyAvatar />*/}
							{/*	</ReferenceField>*/}
							{/*</Box>*/}
						</Box>
					</CardContent>
				</Card>
			</Box>
			<ComplexAside link="edit" />
		</Box>
	);
};
